// extracted by mini-css-extract-plugin
export default {"thresholdTextField":"PerspectiveConfig-thresholdTextField-bc7de229e863c7fdda03b812740ed6b8"};